<template>
  <div class="home w-full h-full absolute top-0 left-0 flex flex-col">
    <transition name="fade-05">
      <div @click="menuUserIsOpen=!menuUserIsOpen" v-if="menuUserIsOpen" class="absolute h-full w-full bg-primary-900 opacity-50" style="z-index: 100;"></div>
    </transition>
    <div @click="menuIsOpen=!menuIsOpen" v-if="menuIsOpen" class="absolute h-full w-full bg-primary-900 opacity-50" style="z-index: 100;"></div>
    <header class="w-full flex h-18 items-center justify-between bg-primary-900 px-5" style="z-index:100;">
      <div @click="menuIsOpen=!menuIsOpen"
          :class="{'menu-icon-open':menuIsOpen}"
          class="menu-icon md:hidden mr-4">
          <i></i>
      </div>
      <div class="inline-block mr-5">
        <img v-if="darkMode" class="h-12 w-full" src="~@/assets/img/logos/logo-obenasa-inv.png" alt="">
        <img v-if="!darkMode" class="h-12 w-full" src="~@/assets/img/logos/logo-obenasa.png" alt="">
      </div>

      <div @click="menuUserIsOpen=!menuUserIsOpen" class="flex items-center ml-auto hover:bg-primary-700 open-modal-perfil cursor-pointer p-1">
        <p class="ml-2 text-primary-200 hidden md:inline-block">{{ emailUser}}</p>
        <div class="h-12 w-12 overflow-hidden rounded-full ml-2">
          <img class="transition-200" src="~@/assets/img/test-user.png" alt="">
        </div>
       <span class="k-icon k-i-more-vertical ml-2 text-primary-200"></span>
      </div>

      <!-- modal perfil   -->
      <transition name="modal-fade-down">
        <div @click="menuUserIsOpen=!menuUserIsOpen" v-if="menuUserIsOpen" class="modal-perfil absolute max-w-xs rounded-lg overflow-hidden" style="min-width: 200px;">
          <ul>
            <li class="hover:bg-primary-700 h-12 flex items-center cursor-pointer px-4">
             <router-link :to="{name:'userProfile'}" class="flex items-center">
               <span class="vsm--icon icon-config mr-2 text-blue-500"></span>
               <p>Ajustes de Perfil</p>
             </router-link>
              <!-- <span class="vsm--icon icon-config mr-2 text-blue-500"></span><p>Ajustes de Perfil</p> -->
            </li>
            <li class="hover:bg-primary-700 h-12 flex items-center cursor-pointer relative px-4" @click="changeTheme" >
              <transition name="fade-down">
                <p v-if="darkMode"><span class="vsm--icon icon-light-mode mr-2 text-blue-500"></span>Activar light mode</p>
              </transition>
              <transition name="fade-up">
                <p v-if="!darkMode"><span  class="vsm--icon icon-dark-mode mr-2 text-blue-500"></span>Activar dark mode</p>
              </transition>
            </li>
            <li class="hover:bg-primary-700 h-12 flex items-center cursor-pointer px-4 border-t border-solid border-primary-500" @click="onLogout">
              <span  class="vsm--icon icon-logout mr-2 text-danger"></span><p>Logout</p>
            </li>
          </ul>
        </div>
      </transition>
      <!-- end modal perfil   -->
    </header>
    <div class="flex w-full relative overflow-hidden relative" style="max-width: 100vw; height: calc(100% - 73px)">
      <!-- <div class="flex flex-col transition-200 menu-global" :class="[!isCollapsed ? 'wide-menu-width':'tight-menu-width']"> -->
      <div class="flex flex-col transition-200 menu-global md:max-w-widemenu md:overflow-visible" :class="[!isCollapsed ? 'max-w-widemenu':'max-w-tightmenu', {'max-w-zero':!menuIsOpen}]" style="z-index:100">
        <div class="w-full flex items-center px-5 h-13 bg-primary-700 k-text-ellipsis">
          <p class="text-xs k-text-ellipsis">Está en: <span class="text-light">{{ menuItem }}</span></p>
        </div>
        <sidebar-menu :menu="menu"
                      width="260px"
                      @toggle-collapse="isCollapsed=!isCollapsed"
                      @item-click="onItemClick">
                      <span slot="dropdown-icon" class="icon-arrow"></span>
                      <span slot="toggle-icon" class="icon-collapse"></span>
        </sidebar-menu>
        <transition name="fade-copyright">
          <span v-show="!isCollapsed" class="text-xs text-primary-200 p-4 bg-primary-800 k-text-ellipsis">
            Ⓒ 2019 - Zerocoma S.L. / V-1.0.1
          </span>
        </transition>
        <transition name="fade-copyright">
          <span v-show="isCollapsed" class="text-xs text-primary-200 p-4 bg-primary-800 k-text-ellipsis text-center">
            Ⓒ
          </span>
        </transition>
      </div>
      <transition name="fade-up">
        <router-view class="transition-200 right-0 overflow-hidden relative" :class="[!isCollapsed ? 'wide-table-width':'tight-table-width']"></router-view>
      </transition>
    </div>
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import getFacturas from '../utils/solpheoListFacturas'

export default {
  computed: {
    ...mapState(['totalFacturas', 'totalEnTramite', 'totalAceptadas', 'totalRechazadas', 'menuItem', 'loading']),
    ...mapGetters(['getTotalFacturas'], ['getFacturasEnTramite'], ['getMenuItem'], ['getLoading']),
    menu: {
      get () {
        return [
          {
            href: '/send-invoices',
            title: 'Enviar facturas',
            class: 'menu-border-b double-menu-border-b filter-active',
            icon: 'icon-send'

          },
          {
            href: '/list/1',
            title: 'Facturas',
            class: 'menu-border-b filter-active',
            icon: 'icon-factura',
            badge: {
              text: this.totalFacturas,
              class: 'bubble-facturas'
            }
          },
          {
            href: '/list/2',
            title: 'Aceptadas',
            class: 'menu-border-b bubble-c03 filter-active',
            icon: 'icon-incidencia',
            badge: {
              text: this.totalAceptadas,
              class: 'bubble-c06'
            }
          },
          {
            href: '/list/3',
            title: 'Rechazadas',
            class: 'menu-border-b bubble-c04 filter-active',
            icon: 'icon-asignacion',
            badge: {
              text: this.totalRechazadas,
              class: 'bubble-c03'
            }
          },
          {
            href: '/list/4',
            title: 'En Trámite',
            class: 'menu-border-b bubble-c05 filter-active',
            icon: 'icon-shape-doc',
            badge: {
              text: this.totalEnTramite,
              class: 'bubble-c05'
            }
          }
        ]
      },
      set () {
        return [
          {
            href: '/send-invoices',
            title: 'Enviar facturas',
            class: 'menu-border-b double-menu-border-b filter-active',
            icon: 'icon-send'
          },
          {
            href: '/list/1',
            title: 'Facturas',
            class: 'menu-border-b filter-active',
            icon: 'icon-factura',
            badge: {
              text: '0',
              class: 'bubble-facturas'
            }
          },
          {
            href: '/list/2',
            title: 'Aceptadas',
            class: 'menu-border-b bubble-c03',
            icon: 'icon-incidencia',
            badge: {
              text: '0',
              class: 'bubble-c03'
            }
          },
          {
            href: '/list/3',
            title: 'Rechazadas',
            class: 'menu-border-b bubble-c04',
            icon: 'icon-asignacion',
            badge: {
              text: '0',
              class: 'bubble-c04'
            }
          },
          {
            href: '/list/4',
            title: 'En Trámite',
            class: 'menu-border-b bubble-c05  filter-active',
            icon: 'icon-shape-doc',
            badge: {
              text: '0',
              class: 'bubble-c05'
            }
          },
          {
            href: '/list',
            title: 'P.Contabilizar',
            class: 'menu-border-b bubble-c06',
            icon: 'icon-contabilizar',
            badge: {
              text: '24',
              class: 'bubble-c06'
            }
          },
          {
            href: '/list',
            title: 'Contabilizadas',
            class: 'menu-border-b bubble-c08',
            icon: 'icon-aprobacion',
            badge: {
              text: '24',
              class: 'bubble-c08'
            }
          },
          {
            href: '/approval',
            title: 'Aprobación',
            class: 'menu-border-b double-menu-border-t filter-active',
            icon: 'icon-aprobacion',
            badge: {
              class: 'bubble-facturas'
            }
          },
          {
            title: 'Gestión',
            class: 'double-menu-border-t filter-active',
            icon: 'icon-config',
            child: [
              {
                href: { name: 'supplierManagement' },
                title: 'Proveedores'
              },
              {
                href: { name: 'userManagement' },
                title: 'Usuarios'
              }
            ]
          }
        ]
      } }
  },

  name: 'home',

  methods: {
    onItemClick (event, item, node) {
      this.$store.commit('setMenuItem', item.title)
    },
    onChange () {
      this.$router.push({ name: 'documentDetail' })
    },
    onLogout () {
      localStorage.removeItem('token')
      localStorage.removeItem('email')
      console.log('logout')
      this.$router.push({ name: 'login' })
    },
    changeTheme () {
      this.darkMode = !this.darkMode
      this.$emit('myTheme', this.darkMode)
    }
  },
  data: function () {
    return {
      menuIsOpen: false,
      menuUserIsOpen: false,
      isCollapsed: false,
      darkMode: true,
      emailUser: localStorage.getItem('email')
    }
  }
}

</script>
